import { render } from "./TableNotifications.vue?vue&type=template&id=aa5ea5e6&scoped=true"
import script from "./TableNotifications.vue?vue&type=script&lang=js"
export * from "./TableNotifications.vue?vue&type=script&lang=js"

import "./TableNotifications.vue?vue&type=style&index=0&id=aa5ea5e6&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5ea5e6"]])

export default __exports__